// /api/tikz/* kimlik ister (P3 C0): AuthContext'in sakladigi token'i JSON basligina ekler.
export function authBaslik() {
  const h = { 'Content-Type': 'application/json' };
  try { const t = localStorage.getItem('yks_token'); if (t) h.Authorization = `Bearer ${t}`; } catch { /* depolama yok */ }
  return h;
}
